import React, { useRef, useState } from 'react'
import Overlay from 'react-bootstrap/Overlay'
import Tooltip from 'react-bootstrap/Tooltip'

export default function Cart(){
    const btnRef = useRef()
    const [show, setShow] = useState(false)

    return(
        <>
            <button
                ref={btnRef}
                style={{ background: 0, border: 0, padding: 0 }}
                onClick={async () => {
                    if(typeof window === 'undefined') return
                    window.fastspring.builder.viewCart(data => {
                        if(!data){
                            setShow(true)
                            setTimeout(() => setShow(false), 2000)
                        } else {
                            setShow(false)
                        }
                    })
                }}
            >
                <img src='/svg/cart-icon-white.svg' />
            </button>

            <Overlay target={btnRef.current} show={show} placement="bottom">
                <Tooltip>
                    Basket is empty
                </Tooltip>
            </Overlay>
        </>
    )
}
